import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faHeart, faBrain, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export default function IceBreakerGuide({ onClose }) {
  const steps = [
    {
      title: "Welcome to ❄️ IceBreaker",
      desc: "Reconnect • Resolve • Restore relationships — guided by Thinky AI. This is not therapy, and it’s non-judgmental.",
      icon: faHeart,
      button: "Next"
    },
    {
      title: "Consent First",
      desc: "IceBreaker will only start if all participants consent. Click 'I Understand & Consent' to proceed when ready.",
      icon: faHeart,
      button: "Next"
    },
    {
      title: "Search Conflicts",
      desc: "Use the search bar to find a person or group to reconnect with. Conflicts are listed with relationship type, intensity, reason, and duration.",
      icon: faBrain,
      button: "Next"
    },
    {
      title: "Select Icebreaking Technique",
      desc: "Choose a technique that fits your situation: Emotional ❤️, Reframing 🔄, Curiosity ❓, Apology 🙏, Cooling ⏳. Each guides Thinky AI's message drafts.",
      icon: faBrain,
      button: "Next"
    },
    {
      title: "Guided Conversation",
      desc: "AI drafts messages for you. Edit them if needed. Send and track simulated sentiment: negative, neutral, or positive. Positive sentiment indicates progress.",
      icon: faBrain,
      button: "Next"
    },
    {
      title: "Outcome & Reflection",
      desc: "Thinky AI tracks steps taken and conversation outcome. Reflect on root causes using Think5Whys methodology. Explore growth opportunities.",
      icon: faBrain,
      button: "Next"
    },
    {
      title: "Next Steps & Escalation",
      desc: "Continue gradually if tension is high. Take breaks. Involve a human mediator if needed. Always ensure privacy and respect.",
      icon: faTriangleExclamation,
      button: "Finish"
    }
  ];

  const [currentStep, setCurrentStep] = useState(0);

  const nextStep = () => {
    if (currentStep < steps.length - 1) setCurrentStep(currentStep + 1);
    else onClose(); // close guide on finish
  };

  const { title, desc, icon, button } = steps[currentStep];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 p-4">
      <div className="bg-zinc-900 rounded-2xl p-6 max-w-md w-full text-center space-y-4 shadow-lg">
        <FontAwesomeIcon icon={icon} className="text-violet-400 text-4xl mx-auto" />
        <h2 className="text-lg font-bold text-yellow-200">{title}</h2>
        <p className="text-sm text-violet-200">{desc}</p>
        <button
          onClick={nextStep}
          className="mt-4 bg-violet-600 hover:bg-violet-500 px-6 py-2 rounded-full text-white font-semibold flex items-center justify-center gap-2 mx-auto"
        >
          {button} <FontAwesomeIcon icon={faArrowRight} />
        </button>
        <div className="flex justify-center space-x-2 mt-2">
          {steps.map((_, idx) => (
            <div
              key={idx}
              className={`w-3 h-3 rounded-full ${
                idx === currentStep ? "bg-violet-400" : "bg-zinc-700"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
